import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { SpinnerService } from 'src/core/services/spinner.service';
import { Location } from '@angular/common';
import { UserRole,UserRoleNames } from 'src/core/helpers/user-roles';
import { AuthenticationService } from 'src/core/services/authentication.service';
import { Boards } from 'src/core/helpers/boards';
import { UserService } from 'src/core/services/user.service';
import { Member } from '../shared/models/member';
import { NotificationService, Notification } from 'src/app/search-assign/shared/services/notification.service';
import { LabelUser } from '../shared/models/label-user';

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class MembersComponent implements OnInit, OnDestroy {
  boardId!: string;
  routerSubscription!: Subscription;
  currentUser: any;
  members: Member[] = [];
  @Input() roles: any[] = [];
  newMember = { email: '', role: '' };
  newMemberEmail = '';
  newMemberRole = '';
  emptyId='00000000-0000-0000-0000-000000000000';
  activeNotification: Notification | null = null;
  notificationTimer: any;
  private notificationSubscription!: Subscription;
  membersLoaded = false;
  labelUsers: LabelUser[] = [];

  inviteForm = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    userRole: ['', Validators.required],
  });

  activeSubmenu: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private userService: UserService,
    private spinnerService: SpinnerService,
    private location: Location,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser')!);
    this.routerSubscription = this.route.params.subscribe((params: any) => {
      if (params.id) this.boardId = params.id;
      else {
        this.boardId = JSON.parse(
          localStorage.getItem('currentUser')!
        ).board.id;
        this.location.replaceState(
          window.location.pathname + '/' + this.boardId
        );
      }
    });

    this.notificationSubscription = this.notificationService.notification$.subscribe(notification => {
      this.showNotification(notification);
    });

    //this.getRoles();
    this.getLabelMembers();
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
    if (this.notificationTimer) {
      clearTimeout(this.notificationTimer);
    }
  }

  showNotification(notification: Notification): void {
    if (this.notificationTimer) {
      clearTimeout(this.notificationTimer);
    }
    this.activeNotification = notification;
    this.notificationTimer = setTimeout(() => {
      this.activeNotification = null;
    }, 5000);
  }

  getLabelMembers() {
    //this.spinnerService.show();
    this.membersLoaded = false; 
    this.userService.getLabelUsersByBoardId(this.boardId).subscribe((response: any) => {
      this.labelUsers = response.data;
      this.membersLoaded = this.labelUsers.length > 0; 
      //this.spinnerService.hide();
    });
  }

  otherActionMenu: MenuItem[] = [];
  showActionMenuToggle(member: any, event: MouseEvent, menu: any) {
    this.otherActionMenu = this.getMenuItems(member);
    menu.toggle(event);
  }

  getRoles() {
    //this.spinnerService.show();
    this.userService.getAllRoles().subscribe((rolesResponse: any) => {
      if (this.boardId == Boards.MPO || this.boardId == Boards.MNN) {
        this.roles = rolesResponse.data.filter(
          (role: any) => role.name === UserRoleNames.Superadmin
        );
      } else {
        // check logged in user if Superadmin
        let userRole = JSON.parse(localStorage.getItem('currentUser')!).user
          .roleName;
        if (userRole === UserRoleNames.Superadmin) {
          this.roles = rolesResponse.data.filter(
            (role: any) => role.name !== UserRoleNames.Superadmin
          );
        } else {
          this.roles = rolesResponse.data.filter(
            (role: any) =>
              role.name !== UserRoleNames.Superadmin && role.name !== UserRoleNames.LabelAgent
          );
        }
      }
      // Sort roles by name in ascending order
      this.roles.sort((a, b) => a.name.localeCompare(b.name));
      //this.spinnerService.hide();
    });
  }

  get UserRoleNames()
  {
    return UserRoleNames;
  }

  sendInvitation() {
    // Logic to send invitation
    let _email = this.inviteForm.getRawValue().email;
    let _userRole: any = this.inviteForm.getRawValue().userRole;

    this.userService
      .sendInvitation(_email!, this.boardId, _userRole!.id)
      .subscribe(
        (response) => {
          this.notificationService.showSuccess(`Invitation successfully sent to ${_email} as ${_userRole.name}.`);

          this.inviteForm.reset();

          this.getLabelMembers();
        },
        (err: any) => {
          this.notificationService.showError('Invitation failed to send');
        }
      );

      
  }

  getMenuItems(currentRow: any): MenuItem[] {
    return [
      { visible: false },
      {
        label: 'Re-invite member',
        command: () => this.resendInvitation(currentRow),
        visible:
          currentRow.user.id === this.emptyId &&
          !(
            currentRow.role.name === UserRoleNames.LabelAgent &&
            this.currentUser.user.roleName === UserRoleNames.LabelAdmin
          ),
      },
      {
        label: 'Delete invitation',
        command: () => this.deleteInvitation(currentRow),
        visible:
          currentRow.user.id === this.emptyId &&
          !(
            currentRow.role.name === UserRoleNames.LabelAgent &&
            this.currentUser.user.roleName === UserRoleNames.LabelAdmin
          ),
      },
      {
        label: 'Delete Member',
        command: () => this.deleteMember(currentRow),
        visible: currentRow.user.id !== this.emptyId,
      },
    ];
  }
  
  deleteInvitation(invitationId: string): void {
    this.userService.deleteInvitation(invitationId).subscribe((res: any) => {
      this.notificationService.showSuccess('Delete Success');
      this.getLabelMembers();
    },
    (err: any) => {
      this.notificationService.showError('Delete failed');
    });
  }
  
  deleteMember(id: string): void {
    this.userService.deleteLabelMember(id).subscribe(
      (res) => {
        this.notificationService.showSuccess('Delete Success');
        this.getLabelMembers();
      },
      (err) => {
        this.notificationService.showError('Delete failed');
      }
    );
  }
  
  resendInvitation(currentRow: any): void {
    this.closeSubmenu(new MouseEvent('click'));
    this.userService
      .resendUserInvitation(currentRow.invitationId)
      .subscribe(
        (res: any) => {
          this.notificationService.showSuccess('Re-invitation is sent successfully to ' + currentRow.email);
        },
        (err) => {
          this.notificationService.showError('Re-invitation failed to send');
        }
      );
  }

  onMemberRoleChange(member: any, event: any) {
    this.updateMemberData(member, false);
  }

  onChangeSwitches(member: any, event: any, updateUser: boolean = false) {
    this.updateMemberData(member, updateUser);
  }

  updateMemberData(member: LabelUser, updateUser: boolean) {
    this.userService.updateLabelMember(member, this.boardId).subscribe(
      (response: any) => {
        this.notificationService.showSuccess('Member updated successfully');
        if (updateUser) {
          this.authService.updateMetafireDUserEmail(
            member.userId,
            member.email,
            member.name,
            member.boardId,
            member.receiveNewReports
          ).subscribe((res: any) => {
          }); 
        }
      },
      (err: any) => {
        this.notificationService.showError('Member update failed');
      }
    );
  }

  toggleSubmenu(userEmail: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
        
    if (this.activeSubmenu === userEmail) {
      this.activeSubmenu = null;
    } else {
      // Open submenu for this user (closes any other open submenu)
      this.activeSubmenu = userEmail;
    }
  }

  // Close submenu when clicking outside
  @HostListener('document:click', ['$event'])
  closeSubmenu(event: Event) {
    this.activeSubmenu = null;
  }

  // Prevent closing when clicking inside the submenu
  onSubmenuClick(event: Event) {
    event.stopPropagation();
  }

  toggleFinancialStatements(member: LabelUser) {
    member.receiveFinancialStatements = !member.receiveFinancialStatements;
    this.updateMemberData(member, false);
  }

  toggleNewReports(member: LabelUser) {
    member.receiveNewReports = !member.receiveNewReports;
    this.updateMemberData(member, true);
  }
}

